

// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
 import {Deserializable} from "./deserializable.model";

export class Job {
  public job_id: number;
  public job_number?: string;
  public file_number?: number;
  public brand_id: number;
  public job_type_id: number;
  public client_company_name?: string;
  public client_name?: string;
  public client_phone?: string;
  public special_instructions?: any;
  public report_type_id: number;
  public client_client_id?: number;
  public updated_by?: number;
  public created_date?: string;
  public creatded_by?: number;
  public created_by?: number;
  public owner_trace_code?: string;
  public updated_date?: number;
        // Advanced Fields // Dev Tools
        public project_type: number;
        public allocated_date: string;
        public allocated_to: number;
        public allocated_by: number;
        public status: number;
        public progress_percentage: number;
        public locate_status: number;
        public total_candidates_count: number;
        public completed_candidates_count: number;
        public completed_date: string;
        public trace_api_key: string;

// additional fields for statistics and trackings upgrade
public pl_count: number;
public l_count: number;
public nl_count: number;
public fee: number;
public adverage_trace_time: number;
public total_open: number;
public total_all: number;
public total_all_all: number;
public pl_percent: number;
public l_percent: number;
public nl_percent: number;
public completed_by?: number;
public start_date: string;
public started_by: number;
public time_taken: number;
 
public client_invoice_id: number;
public client_id: number;
// public special_instructions: string;
public job_type_location_id: number;
public job_type_court_id: number;
public job_type_document_type_id: number;
public job_type_affidavit_type_id: number;
public client_contact_id: number;


public hearing_date: string;
public judgement_date: string;
public filing_date: string;
public number_subjects: string;
public instructions_date: string;
public brand_invoice_id: number;
public brand_report_id: number;

job_status_code?: string;
document_page_count?: number;
document_invoice_printing?: string;
job_service_rule_id?: number;
job_service_timeframe_id?: number;

document_number?: string;
registry_name?: string;

special_instructions_HTML?: string;


  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): Job {
    Object.assign(this, input);

    return this;
  }


}

  // Set the Stats
